import { render, staticRenderFns } from "./EditableComment.vue?vue&type=template&id=4b947168&scoped=true&"
import script from "./EditableComment.vue?vue&type=script&lang=js&"
export * from "./EditableComment.vue?vue&type=script&lang=js&"
import style0 from "./EditableComment.vue?vue&type=style&index=0&id=4b947168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b947168",
  null
  
)

export default component.exports